<template>
  <div id="statementOfCashFlow">
    <div class="public-content">
      <div class="statementOfCashFlow_top clearfix">
        <el-form :inline="true" class="fl">
          <el-form-item label="现金流量表：">
                 <el-select v-model="select.reportVal" size="mini" class="report-select" style='width: 80px;'>
                  <el-option
                    v-for="item in options.reportOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          	<el-form-item>
						<template v-if="!isShowQuarter">
							<accounting-period @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
						</template>
						<template v-else>
							<el-date-picker
								v-model="date.nowYearPeriods"
								 style='width: 140px;'
								type="year"
								size="mini"
								class="year-editor"
								placeholder="选择年"
								:clearable="false"
								:picker-options="pickerBeginDateBefore"
								@change="handleYearChange">
							</el-date-picker>
							<el-select v-model="select.quarterVal" size="mini" class="quarter-select" style='width: 120px;'>
								<el-option
									v-for="item in options.quarterOps"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</template>
					</el-form-item>
           <el-form-item label="统计方式：">
                <el-select v-model="form.type" placeholder="请选择" size='mini' style='width: 160px' @change='getTableList'>
                  <el-option
                    v-for="item in statisticsWayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" class="minButton" @click="getTableList">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="fr">
          <!-- <el-button size="mini" class="minButton" @click="handleJump_extraData" v-show='form.type!=1'>表外数据</el-button> -->
          <template v-for="(item,index) in permiss">
            <print-operation
              v-if="item.permission == 'cash:flow:print'"
              :key="index"
              :formData="printForm"
              :showContinuit="false"
            ></print-operation>
            <el-button
              v-if="item.permission == 'cash:flow:export'"
              :key="index"
              size="mini"
              @click="handleDownload"
            >导出</el-button>
          </template>
        </div>
      </div>
      <public-table :table="tableData">

        <template slot-scope="props"  slot='re1.name' v-for="(item,index) in tableData.config" >
          <div v-if="form.type==0" :key="index">
            <el-link type="primary" 
            :underline="false" 
            @click="handlerClick(props.scope.row.re1)"
            v-if="props.scope.row.re1.style !== '3' && props.scope.row.re1.style !== '4'" 
            >
            {{props.scope.row.re1.name}}
            </el-link>
           <span v-else>{{props.scope.row.re1.name}}</span>
          </div>
          <div v-else :key="index">
            <span >{{props.scope.row.re1.name}}</span>
          </div>
        </template>
           <template slot-scope="props"  slot='re2.name' v-for="(item,index) in tableData.config" >
          <div v-if="form.type==0" :key="index">
            <el-link type="primary" 
            :underline="false" 
            @click="handlerClick(props.scope.row.re2)"
            v-if="props.scope.row.re2.style !== '3' && props.scope.row.re2.style !== '4'" 
            >
            {{props.scope.row.re2.name}}
            </el-link>
           <span v-else>{{props.scope.row.re2.name}}</span>
          </div>
          <div v-else :key="index">
            <span >{{props.scope.row.re2.name}}</span>
          </div>
        </template>
        <template slot-scope="props" slot="re1.rowNumber">
          <span >{{props.scope.row.re1.rowNumber}}</span>
        </template>
         <template slot-scope="props" slot="re2.rowNumber">
          <span >{{props.scope.row.re2.rowNumber}}</span>
        </template>
        <template slot-scope="props" slot="re1.countYearNumber">
          <el-input
            size="mini"
            v-if="props.scope.row.re1.update"
            v-model="props.scope.row.re1.countYearNumber"
            placeholder='可输入金额'
            @focus="handleEditField($event, props.scope.row.re1)"
            @blur="handleCancelEdit($event, props.scope.row.re1)"
          ></el-input>
          <span v-text="props.scope.row.re1.countYearNumber" v-else></span>
        </template>
        <template slot-scope="props" slot="re1.periodsNumber">
          <el-input
            v-model="props.scope.row.re1.periodsNumber"
            size="mini"
            placeholder='可输入金额'
            v-if="props.scope.row.re1.update"
            @focus="handleEditField($event, props.scope.row.re1)"
            @blur="handleCancelEdit($event, props.scope.row.re1)"
          ></el-input>
          <span v-text="props.scope.row.re1.periodsNumber" v-else></span>
        </template>

        <template slot-scope="props" slot="re2.countYearNumber">
          <el-input
            v-model="props.scope.row.re2.countYearNumber"
            size="mini"
             v-if="props.scope.row.re2.update"
            @focus="handleEditField($event, props.scope.row.re2)"
            @blur="handleCancelEdit($event, props.scope.row.re2)"
          ></el-input>
          <span v-text="props.scope.row.re2.countYearNumber" v-else></span>
        </template>
        <template slot-scope="props" slot="re2.periodsNumber">
          <el-input
            v-model="props.scope.row.re2.periodsNumber"
            size="mini"
            v-if="props.scope.row.re2.update"
            @focus="handleEditField($event, props.scope.row.re2)"
            @blur="handleCancelEdit($event, props.scope.row.re2)"
          ></el-input>
          <span v-text="props.scope.row.re2.periodsNumber" v-else></span>
        </template>
      </public-table>
      <balance-sheet-dialog
        :ruleOfFetch="'余额'"
        :dialogVisible.sync="isShowReport"
        @onRefresh='onRefresh'
        :data="reportDialogData"
        :showRegulation="true">
      </balance-sheet-dialog>
    </div>
  </div>
</template>
<script>
import printOperation from "@/components/print";
import publicTable from "@/components/publicTable";
import accountingPeriod from "@/components/dialog/accountingPeriod";
import {currencys} from '@/assets/utils/currencyFormat'
import balanceSheetDialog from '@/components/dialog/balanceSheetDialog'
export default {
  components: {
    publicTable,
    accountingPeriod,
    printOperation,
    balanceSheetDialog
  },
  computed:{
    	// 是否显示季报
			isShowQuarter () {
				this.form = Object.assign({}, this.form, {
					quarter: this.select.reportVal != '1' ? this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyy') + this.select.quarterVal : '',
					yearPeriods: this.select.reportVal == '1' ? (this.form.yearPeriods ? this.form.yearPeriods : this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyyMM')) : ''
				})
				this.$set(this.printForm, 'data', {
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				})
				return this.select.reportVal === '1' ? false : true;
			},
  },
  data() {
    return {
      	pickerBeginDateBefore: {
					disabledDate: (time) => {
						let res = this.$store.state.accountInfo.yearPeriods;
						let beginStartDateVal = this.date.start||res.startTimeStamp;
						let beginEndDateVal = this.date.end||res.endTimeStamp;
						if (beginEndDateVal && beginEndDateVal) {
							return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
						}
					}
				},
        select: {			// 选择框数据
					reportVal: '1',
					quarterVal: '_1'
				},
      	date: {			// 日期控件参数
					start: '',
					end: '',
					nowYearPeriods: ''
				},
      	options: {			// 选择框option数据
					reportOps: [{
						label: '月报',
						value: '1',
					},{
						label: '季报',
						value: '2',
					}],
					quarterOps: [{
						label: '第一季度',
						value: '_1',
					},{
						label: '第二季度',
						value: '_2',
					},{
						label: '第三季度',
						value: '_3',
					},{
						label: '第四季度',
						value: '_4',
					}],
				},
      reportDialogData: {
					reportId: '',
					yearPeriods: '',
					style: '1'
			},
      isShowReport:false,
      form: {
        yearPeriods: "",
        type:1,
      },
      statisticsWayList: [{
          value: 0,
          label: '公式法'
        }, {
          value: 1,
          label: '分配法'
        }],
        value: '',
      showModifyMoney: false, // 显示修改金额
      getOnce: true, // 执行一次
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: false, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: false, // 是否显示分页
        config: [
          {
            label: "项目",
            value: "re1.name",
            name: "re1",
            width: 210,
            show: "template"
          },
          {
            label: "行次",
            value: "re1.rowNumber",
            width: 80,
            show: "template"
          },
          {
            label: "本年累计金额",
            value: "re1.countYearNumber",
            show: "template"
          },
          {
            label: "本期金额",
            value: "re1.periodsNumber",
            show: "template"
          },
          {
            label: "项目",
            value: "re2.name",
            name: "re2",
            width: 210,
            show: "template"
          },
          {
            label: "行次",
            value: "re2.rowNumber",
            width: 80,
            show: "template"
          },
          {
            label: "本年累计金额",
            value: "re2.countYearNumber",
            show: "template"
          },
          {
            label: "本期金额",
            value: "re2.periodsNumber",
            show: "template"
          }
        ],
        operation: {
          label: "操作",
          value: "operation",
          data: []
        },
        data: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          count: 10
        },
        center: {
          textAlign: "center",
          padding: "6px 0"
        }
      },
      list: [], // 修改后的数据
      superPrevent: true, // 防止不做修改提交
      newcountYearNumber: "", // 当前本年累计金额
      nowperiodsNumber: "", // 当前本月金额
      arrBtn: ["cash:flow:print", "cash:flow:export"],
      // 按钮权限
      permiss: [],
      printForm: {
        data: {
          quarter: '',
          yearPeriods: "",
          type:"",
        },
        url: "/createPDF/PrintStatementOfCashFlow",
        continuityUrl: "/createPDF/PrintStatementOfCashFlow"
      }
    };
  },
  created() {
    const isMInjian = JSON.parse(sessionStorage.getItem('accountInfo')).accountingSystemCode==70;
    if(isMInjian) {
      this.form.type = 1
    }else {
      this.form.type = 0
    }
    this.findPermissionMenu();
  },
  mounted() {
    const isMInjian = JSON.parse(sessionStorage.getItem('accountInfo')).accountingSystemCode==70;
    if(isMInjian) {  // 民间非营利没有公式法
      this.statisticsWayList =  [{
          value: 1,
          label: '分配法'
        }]
    }else {
      this.statisticsWayList =  [{
          value: 0,
          label: '公式法'
        }, {
          value: 1,
          label: '分配法'
        }]
    }
  },
  methods: {
    // 选择期数
			handleYearChange (val) {
				this.$set(this.form, 'quarter', this.$util.formatDate.format(val, 'yyyy')+this.form.quarterVal);
				this.$set(this.printForm.data, 'quarter', this.form.quarter)
			},
    // 刷新页面
			onRefresh(data) {
				if(data) {
					this.getTableList();
				}
			},
    // 表格点击事件
			handlerClick(row) {
        if(this.form.type==1){
          return 
        }
				this.reportDialogData = Object.assign(this.reportDialogData, {
					reportId: row.id,
					yearPeriods: this.form.yearPeriods,
					style: row.style,
          quarter:this.form.quarter
				})
				this.isShowReport = true;
			},
    //查询权限
    findPermissionMenu() {
      const _ = this;
      let params = {
        permissions: _.arrBtn.join(",")
      };
      _.$http
        .post("sys/menu/findPermissionMenu", params)
        .then(res => {
          if (res && res.data.code == "1") {
            this.permiss = res.data.data;
          }
        })
        .catch(e => {});
    },
    // 批量保存
    handleBatchSave() {
      if (this.superPrevent) {
        return this.$message.warning("您还没有做任何修改哟！");
      }
      let params = {
        list: this.list,
        yearPeriods: this.form.yearPeriods,
        type: this.form.type
      };
      try {
        this.$http
          .post("reportFormSonByMon/saveReportSonMon", params)
          .then(res => {
            if (res && res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.superPrevent = true;
              this.getTableList();
              this.list = [];
            }
          });
      } catch (e) {}
    },
    // 失去焦点
    handleCancelEdit(e, row, name) {
      if (this.newcountYearNumber == row.countYearNumber && this.nowperiodsNumber == row.periodsNumber) {
        this.superPrevent = true;
        return;
      } else {
        this.superPrevent = false;
        let params = {
          countYearNumber: row.countYearNumber?Number(row.countYearNumber.replace(/\,/g,"")):0,
          reporFromId: row.id,
          periodsNumber: row.periodsNumber?Number(row.periodsNumber.replace(/\,/g,"")):0,
          yearPeriods:this.isShowQuarter?'':row.yearPeriod,
          quarter:this.form.quarter
        };
        if(params.countYearNumber<0 || isNaN(params.countYearNumber)) {
            return this.$message.error('本年累计只能输入正数哟！')
        }
         if(params.periodsNumber<0  || isNaN(params.periodsNumber)) {
            return this.$message.error('本期金额只能输入正数哟！')
        }

         this.$http.post("reportform/saveCashFlow", params).then(res=>{
            if(res.data && res.data.code==1) {
              this.$message.success('修改成功！');
               this.getTableList();
            }
         })
      }
    },
    // 获取焦点
    handleEditField(e, row, name) {
      const input = e.target;
      input.select();
      this.newcountYearNumber = row.countYearNumber;
      this.nowperiodsNumber = row.periodsNumber;
    },
    // 接收会计期间数据
    defaultTime(data) {
      this.form = Object.assign(this.form, {
        yearPeriods: this.$util.formatDate.format(
          data.yearPeriodsStart,
          "yyyyMM"
        )
      });
      this.date = Object.assign({}, this.date, {
					start: data.defaultStartDate,
					end: data.defaultEndDate,
					nowYearPeriods: data.yearPeriodsStart
			})
      this.printForm.data.yearPeriods = this.form.yearPeriods;
      if (this.getOnce) {
        this.getOnce = false;
        this.getTableList();
      }
    },
    handleJump_extraData() {
      this.$router.push({ path: "/extraData" });
    },
    // 获取表格数据
    getTableList() {
      try {
        this.tableData.loading = true;
        this.$http
          .post("reportform/statementOfCashFlow", this.form)
          .then(res => {
            this.tableData.loading = false;
            if (res.data&&res.data.code==1) {
              this.printForm.data.type = this.form.type;
              if (!res.data.data[0].re1) {
                this.tableData.data = res.data.data.map(i => {
                  i.re1 = i;
                  if(i.re1) {
                     i.re1.countYearNumber = i.re1.countYearNumber?currencys(i.re1.countYearNumber):"";
                     i.re1.periodsNumber = i.re1.periodsNumber?currencys(i.re1.periodsNumber):"";
                  }
                 if(i.re2) {
                    i.re2.countYearNumber = i.re2.countYearNumber?currencys(i.re2.countYearNumber):"";
                    i.re2.periodsNumber = i.re2.periodsNumber?currencys(i.re2.periodsNumber):""
                 }
                      return i;
                });
                
                let config = [
                  {
                    label: "项目",
                    value: "re1.name",
                    name: "re1",
                    show: "template"
                  },
                  {
                    label: "行次",
                    value: "re1.rowNumber",
                    show: "template"
                  },
                  {
                    label: "本年累计金额",
                    value: "re1.countYearNumber",
                    show: "template"
                  },
                  {
                    label: "本期金额",
                    value: "re1.periodsNumber",
                    show: "template"
                  }
                ];
                console.log(this.tableData)
                if(JSON.parse(sessionStorage.getItem('accountInfo')).accountingSystemCode==70) {
                   config.pop();
                }else if(JSON.parse(sessionStorage.getItem('accountInfo')).accountingSystemCode==72) {
                     config[config.length-1].label = '本期金额'
                }
                this.tableData.config = config;
                console.log(this.tableData)
              } else {
                 this.tableData.config = [
                  {
                    label: "项目",
                    value: "re1.name",
                    name: "re1",
                    width: 210,
                    show: "template"
                  },
                  {
                    label: "行次",
                    value: "re1.rowNumber",
                    width: 80,
                    show: "template"
                  },
                  {
                    label: "本年累计金额",
                    value: "re1.countYearNumber",
                    show: "template"
                  },
                  {
                    label: "本期金额",
                    value: "re1.periodsNumber",
                    show: "template"
                  },
                  {
                    label: "项目",
                    value: "re2.name",
                    name: "re2",
                    width: 210,
                    show: "template"
                  },
                  {
                    label: "行次",
                    value: "re2.rowNumber",
                    width: 80,
                    show: "template"
                  },
                  {
                    label: "本年累计金额",
                    value: "re2.countYearNumber",
                    show: "template"
                  },
                  {
                    label: "本期金额",
                    value: "re2.periodsNumber",
                    show: "template"
                  }
                ];
                this.tableData.data = res.data.data.map(i=>{
                  if(i.re1) {
                     i.re1.countYearNumber = i.re1.countYearNumber?currencys(i.re1.countYearNumber):"";
                     i.re1.periodsNumber = i.re1.periodsNumber?currencys(i.re1.periodsNumber):"";
                  }
                 if(i.re2) {
                    i.re2.countYearNumber = i.re2.countYearNumber?currencys(i.re2.countYearNumber):"";
                    i.re2.periodsNumber = i.re2.periodsNumber?currencys(i.re2.periodsNumber):""
                 }
                  
                  return i;
                });
              }
            }
          });
      } catch (e) {
        this.tableData.loading = true;
      }
    },
    // 导出
    handleDownload() {
      const params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        yearPeriods: this.form.yearPeriods,
        type: this.form.type,
        quarter: this.form.quarter
      };
      const router = this.$router.resolve({
        path: "/export/exportStatementOfCashFlow",
        query: params
      });
      window.open(this.$rootUrl + router.href, "_blank");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/reportForm/statementOfCashFlow.vue